import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { ResponseStatus } from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { EmployeePayrollItemModel } from './employee-payroll-item.model';

export const entityName = 'EmployeePayrollItem';
@Injectable({ providedIn: 'root' })
export class EmployeePayrollItemDataService extends EfaactDataService<EmployeePayrollItemModel> {
    mapItems(item: EmployeePayrollItemModel): EmployeePayrollItemModel {
        return {
            ...item,
            id: `${item.EmployeeListID}-${item.PIListID}`,
            Status: {
                StatusCode: ResponseStatus.None,
                Message: ''
            }
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
